import { render, staticRenderFns } from "./t.vue?vue&type=template&id=130dd254&scoped=true&"
import script from "./t.vue?vue&type=script&lang=js&"
export * from "./t.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130dd254",
  null
  
)

export default component.exports